export function anchors() {

    $(document).ready(function(){
        $( "a.scrollLink" ).click(function( event ) {
            event.preventDefault();

            if ($(window).width() > 1200) {
                var height = $(".main-header").height();
                $("html, body").animate({ scrollTop: $($(this).attr("href")).offset().top-height }, 500);
            } else {
                $("html, body").animate({ scrollTop: $($(this).attr("href")).offset().top }, 500);
            }
        });
    });


}


// WEBPACK FOOTER //
// ./assets/js/modules/anchors.js